import type { UserTraits } from '@customerio/cdp-analytics-browser';

export const AnalyticsEvent = {
  // Soon to be deprecated:
  INPUT_PATIENT_SELECTED_CATEGORY: 'input_patient_selected_category',
  INPUT_PAYORS_AND_ZIP: 'input_payors_and_zip',
  TELEHEALTH_BOOKING_STEP_RESERVATION_SUBMITTED_DATE_TIME:
    'telehealth_booking_step_reservation_submitted_date_time',

  DTC_ORDER_REJECTED: 'dtc_order_rejected',
  DTC_TELEHEALTH_BOOKING_SELECTED: 'dtc_telehealth_booking_selected',
  DTC_TELEHEALTH_BOOKING_CONFIRMED: 'dtc_telehealth_booking_confirmed',
  DTC_TELEHEALTH_BOOKING_REJECTED: 'dtc_telehealth_booking_rejected',
  DTC_CONTACT_INFO_SUBMITTED: 'dtc_contact_info_submitted',
  DTC_INSURANCE_SEND_LINK: 'dtc_insurance_send_link',
  ELIGIBILITY_CHECKPOINT: 'eligibility_checkpoint',

  SESSION_RESUMED: 'session_resumed',
} as const;

export interface AnalyticsUserTraits extends UserTraits {
  recipient: string;
  email: string;
  phone: string;
  phoneVerified: boolean;
  patientFirstName: string;
  patientLastName: string;
  patientDateOfBirth: string;
  patientGender: string;
  patientTimezone: string;
  representativeFirstName: string;
  representativeLastName: string;
  representativeRelationship: string;
  representativeAuthorizedForMedicalDecisions: string;
}
